export default __webpack_public_path__ + "static/media/icon_schedule.adf09a5f.svg";